import React , { useEffect, useState , useCallback } from 'react'
import MediaDevices from 'media-devices'
import { useZxing } from "react-zxing";
import { BarcodeFormat, DecodeHintType } from "@zxing/library";
import Select from 'react-select'

function QRCode() {
    const [scannedBarcode,setScannedBarcode] = useState([])
    const [devices,setDevices] = useState(null)
    const [scannedDeviceId,setScannedDeviceId] = useState(null)
    const [selectedDeviceId,setSelectedDeviceId] = useState(null)
    const [isScaStart,setScanStart] = useState(false)

    const hints = new Map();
    const formats = [BarcodeFormat.QR_CODE,BarcodeFormat.CODE_39]
    hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
    

    async function getMediaDevices(){
        let devices = await MediaDevices.enumerateDevices()
        let videoDevices = []
        for(let i=0;i<devices.length;i++){
            let device = devices[i]
            if(device.kind=="videoinput"){
                videoDevices.push({label:device.label,value:device.deviceId})
            }
        }
        setDevices(videoDevices)
        //set first device selected
        if(videoDevices.length>0){
            setSelectedDeviceId(videoDevices[0].value)
        }
    }

    useEffect(()=>{
        //getMediaDevices()
    },[])

    const constraints = {
        video: true,
        audio: false,
      };

    const { ref } = useZxing({
        paused: !isScaStart,
        //deviceId: scannedDeviceId,
        constraint: { video: { facingMode: 'environment' }, audio: false },
        hints,
        onResult(result) {
            barcodeScanned(result.getText());
        },
    });

    const barcodeScanned = useCallback((text) => {
        setScannedBarcode((t) => {
            if(t.length > 0 && text===t[0].text){
                return [...t]
            }
            stopScanner()
            return [{text:text,key:new Date().getTime()} , ...t]
        });
    }, []);
    
    async function startScanner(){
        setScanStart(true)
        //setScannedDeviceId(selectedDeviceId)
    }

    function stopScanner(){
        setScanStart(false)
        //setScannedDeviceId(null)        
    }
    
    return (
        <div className="flex flex-col items-center justify-start bg-blue-100 h-screen">

            <div className="w-full h-1/2 border border-indigo-300">
                <video
                    ref={ref}
                    className="w-full h-full"
                    id="videoElement"
                    style={{ border: "1px solid gray" }}
                    loop muted={true} autoPlay playsInline
                />
                
            </div>

            <div className="flex flex-col w-full items-center justify-center h-1/3">
                <div className="flex flex-col w-full items-center justify-center p-4">
                    {/*
                        devices &&
                        <Select 
                            defaultValue={devices[0]}
                            className="w-3/4"
                            options={devices}
                            onChange={(event) => {
                                console.log('onChange event',event)
                                const deviceId = event.value;
                                setSelectedDeviceId(deviceId);
                            }} />
                        */}
                </div>
                <div className="flex flex-row w-full items-center justify-center">
                    <div className="w-1/3 text-center font-medium uppercase p-2 m-4 border border-indigo-300" onClick={startScanner}>Start</div>
                    <div className="w-1/3 text-center font-medium uppercase p-2 m-4 border border-indigo-300" onClick={stopScanner}>Stop</div>
                </div>
            </div>

            {
                scannedBarcode && scannedBarcode.length > 0 &&
                <div className="font-bold uppercase">Barcode scansionati</div>
            }
            <div className="flex flex-col items-center justify-center h-1/3 w-full">
                
                <div className="flex flex-col w-screen h-full overflow-auto">
                    {
                        scannedBarcode && scannedBarcode.map((element,index)=>{
                            return (
                                <textarea key={element.key} style={{resize: "none"}} className="flex-none bg-transparent text-center justify-center w-screen overflow-hidden pt-4 h-10" readOnly value={element.text}></textarea>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default QRCode;
